import { initialize } from '@doordash/lib-feature-flags'
import { createI18nInstance } from '@doordash/lib-i18n'
import { ConfigProps } from '@doordash/lib-i18n/dist/types'
import { has } from 'lodash'
import { TranslationStringKey } from 'translationTypes'
import defaultFeatureFlags from '../defaultFeatureFlags'
import experimentToFeatureFlagMap from '../experimentToFeatureFlagMap'
import * as englishAustraliaStrings from './translations/en-AU.json'
import * as englishCanadaStrings from './translations/en-CA.json'
import * as englishStrings from './translations/en-US.json'
import * as spanishStrings from './translations/es.json'
import * as frenchStrings from './translations/fr-CA.json'
import * as japaneseStrings from './translations/ja-JP.json'
import * as germanGermanyStrings from './translations/de-DE.json'

declare const window

const config: ConfigProps = {
  englishStrings,
  frenchStrings,
  spanishStrings,
  englishCanadaStrings,
  englishAustraliaStrings,
  japaneseStrings,
  germanGermanyStrings,
}

if (has(window, 'view.experiments')) {
  initialize(
    experimentToFeatureFlagMap,
    defaultFeatureFlags,
    window.view.experiments,
    window.view.featureFlagOverrides
  )
}

export const supportedLanguages: Record<string, object> = {
  en_us: {
    name: 'English (US)',
    value: 'en-US',
  },
  en_au: {
    name: 'English (Australia)',
    value: 'en-AU',
  },
  en_ca: {
    name: 'English (Canada)',
    value: 'en-CA',
  },
  fr_ca: {
    name: 'Français',
    value: 'fr-CA',
  },
  es: {
    name: 'Español',
    value: 'es',
  },
  ja: {
    name: '日本語',
    value: 'ja',
  },
  de_de: {
    name: 'Deutsch (Deutschland)',
    value: 'de-DE',
  },
}

const i18n = createI18nInstance(config)

export default {
  ...i18n,
  t: (key: TranslationStringKey, options?: {}) => i18n.t(key, options),
}
